module.exports = __webpack_public_path__ + "img/denglu_bg.6f3a171d.jpg";